var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 176,
    viewBox: "0 0 244 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.181 33.907C201.181 30.7775 200.253 27.7182 198.514 25.1161C196.776 22.514 194.305 20.4858 191.413 19.2882C188.522 18.0906 185.34 17.7772 182.271 18.3878C179.202 18.9983 176.382 20.5053 174.169 22.7183C171.956 24.9312 170.449 27.7506 169.839 30.82C169.228 33.8895 169.542 37.071 170.739 39.9623C171.937 42.8536 173.965 45.3249 176.567 47.0636C179.169 48.8022 182.228 49.7303 185.358 49.7303C189.555 49.7303 193.579 48.0632 196.547 45.0957C199.514 42.1283 201.181 38.1036 201.181 33.907Z",
    fill: "#D7ECF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.27 11.065C214.27 9.7702 213.886 8.50453 213.166 7.42812C212.446 6.35172 211.424 5.51296 210.227 5.01799C209.031 4.52302 207.715 4.39409 206.445 4.64751C205.175 4.90093 204.009 5.52531 203.094 6.44164C202.18 7.35798 201.557 8.52507 201.306 9.79524C201.055 11.0654 201.186 12.3815 201.683 13.5771C202.18 14.7727 203.021 15.7939 204.098 16.5116C205.176 17.2294 206.442 17.6113 207.737 17.609C208.596 17.609 209.446 17.4397 210.24 17.1107C211.033 16.7817 211.754 16.2994 212.36 15.6916C212.967 15.0838 213.448 14.3623 213.776 13.5684C214.103 12.7745 214.271 11.9238 214.27 11.065Z",
    fill: "#D7ECF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.008 84.8313C237.069 109.632 215.522 125.318 205.333 132.237H25.366C15.1223 129.538 6.66514 122.75 2.6223 113.69C-1.93956 103.464 -0.508174 91.1608 6.59412 83.2838C16.1604 72.6402 28.2943 78.7178 37.5874 69.3697C49.3444 57.5475 35.1289 42.6032 45.4764 23.5113C52.5896 10.3395 66.1714 -0.960889 81.6653 0.0647846C94.3894 0.901518 113.352 9.71871 131.103 33.804C146.28 54.4165 161.544 58.9465 165.522 59.9542C196.717 67.8672 220.794 42.6752 235.457 53.0219C247.351 61.3848 241.827 79.649 241.008 84.8313Z",
    fill: "#D7ECF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1610_4754)",
    filter: "url(#filter0_ddd_1610_4754)",
    transform: "translate(50,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 155C80.25 155 87 148.354 87 140.231H57C57 148.354 63.75 155 72 155ZM117 110.692V73.7692C117 51.0985 104.775 32.12 83.25 27.0985V22.0769C83.25 15.9477 78.225 11 72 11C65.775 11 60.75 15.9477 60.75 22.0769V27.0985C39.3 32.12 27 51.0246 27 73.7692V110.692L12 125.462V132.846H132V125.462L117 110.692ZM102 118.077H42V73.7692C42 55.4554 53.325 40.5385 72 40.5385C90.675 40.5385 102 55.4554 102 73.7692V118.077Z",
    fill: "#26B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8929 30.5882C76.2857 27.4118 57.9325 39.6249 51.6429 59.1765L40.1304 100.877C35.2425 116.072 36.3413 119.554 41.4643 132.765H132V125.353L117 111.059V75.0588C117 58.6471 112.179 47.5294 104.143 39.0588C104.143 39.0588 101.981 36.6668 100.393 35.3529C99.0129 34.2113 96.6429 32.7059 96.6429 32.7059L92.8929 30.5882Z",
    fill: "#0093C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1875 39.8C52.9289 39.8 41.25 55.1431 41.25 73.9802V119.554H103.125V73.9802C103.125 55.1431 91.4461 39.8 72.1875 39.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.8235 39.5883C41.6128 39.5883 37.8278 46.0212 36.8819 58.3371C36.8026 59.3702 38.1174 59.5656 38.384 58.5643L38.9747 56.3452C41.0174 48.6726 56.7634 39.5883 48.8235 39.5883Z",
    fill: "#C0E6EC",
    stroke: "#C0E6EC",
    strokeWidth: 1.14755,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1610_4754",
    x: 0,
    y: 0,
    width: 144,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1610_4754"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1610_4754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1610_4754",
    result: "effect2_dropShadow_1610_4754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1610_4754",
    result: "effect3_dropShadow_1610_4754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1610_4754",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no_notifications.84d6509492dce4b9978529a51c10754c.svg";
export { ForwardRef as ReactComponent };